import { RouterModule } from '@angular/router';
import { VisitReservationComponent } from './visit-reservation.component';
import { FormsModule } from '@angular/forms';
import { PersonalVisitSearchComponent } from './component/visit-reservation-search/visit-reservation-search.component';
import { PersonalVisitDetailsDialogComponent } from './component/visit-reservation-details-dialog/visit-reservation-details-dialog.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonUIElementsModule } from '@sdbn/common';
import { TMCTableModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  declarations: [
    VisitReservationComponent,
    PersonalVisitDetailsDialogComponent,
    PersonalVisitSearchComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    RouterModule,
    TMCTableModule,
    CommonLayoutModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonUIElementsModule
  ],
  exports: [
    VisitReservationComponent
  ]
})
export class VisitReservationModule { }
